import {Snippet} from '../../../../../Models/Snippet';
import {format} from 'date-fns';
import * as React from 'react';

function titleForSnippet(snippet: Snippet): string {
    if (snippet.description !== null && snippet.description !== '') {
        return snippet.description;
    }
    if (snippet.publicWorkout.title !== null && snippet.publicWorkout.title !== '') {
        return snippet.publicWorkout.title;
    }
    if (snippet.publicWorkout.trainingPlan && snippet.publicWorkout.trainingPlan.title) {
        return snippet.publicWorkout.trainingPlan.title;
    }

    return 'Quick Session';
}

export function tableColumnTitles(snippets: Snippet[]): Array<React.ReactElement | string> {
    const hasSnippetsOfMultipleUsers =
        snippets.reduce((acc: number[], snippet) => {
            const userId = snippet.publicWorkout.publicUser?.id;
            return userId && !acc.includes(userId) ? [...acc, userId] : acc;
        }, []).length > 1;

    const hasSnippetsOverMultipleDates =
        snippets.reduce((acc: string[], snippet) => {
            const executedAt = format(snippet.publicWorkout.executedAt, 'dd MMM yyyy');
            return executedAt && !acc.includes(executedAt) ? [...acc, executedAt] : acc;
        }, []).length !== snippets.length;

    return snippets.map((snippet) => {
        const title = titleForSnippet(snippet);
        if (hasSnippetsOfMultipleUsers && hasSnippetsOverMultipleDates) {
            return (
                <>
                    {title}
                    <br/>
                    by {snippet.publicWorkout.publicUser?.displayName || 'Unknown'}
                    <br />
                    {format(snippet.publicWorkout.executedAt, 'dd MMM yyyy')}
                </>
            );
        }
        if (hasSnippetsOfMultipleUsers && !hasSnippetsOverMultipleDates) {
            return <>{title} by {snippet.publicWorkout.publicUser?.displayName || 'Unknown'}</>;
        }
        return (
            <>
                {title}
                <br />
                {format(snippet.publicWorkout.executedAt, 'dd MMM yyyy')}
            </>
        );
    });
}
